'use client';

import { useEffect, useRef } from 'react';
import { useAppRouter as useRouter } from '@/lib/navigation';
import { taskToast } from '@/lib/task-toast';

export const HISTORIC_PROCESS_FORBIDDEN_MESSAGE = 'No tienes acceso a este caso.';
export const HISTORIC_TASK_FORBIDDEN_MESSAGE = 'No tienes acceso a este formulario.';
const HISTORIC_FORBIDDEN_FALLBACK_PATH = '/task-list/participated';
export const HISTORIC_FORBIDDEN_TITLE = 'Acceso denegado';

function canNavigateBack(): boolean {
  const browserWindow = globalThis.window;
  if (!browserWindow) {
    return false;
  }

  const referrer = browserWindow.document.referrer;
  if (!referrer) {
    return false;
  }

  try {
    const referrerUrl = new URL(referrer);
    if (referrerUrl.origin !== browserWindow.location.origin) {
      return false;
    }

    return referrerUrl.pathname !== browserWindow.location.pathname;
  } catch {
    return false;
  }
}

export function useHistoricAccessDeniedRedirect(
  denied: boolean,
  message: string = HISTORIC_PROCESS_FORBIDDEN_MESSAGE,
): void {
  const router = useRouter();
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) {
      return;
    }

    const handleDenied = () => {
      handledRef.current = true;

      taskToast.error(HISTORIC_FORBIDDEN_TITLE, {
        description: message,
        position: 'bottom-right',
      });

      if (canNavigateBack()) {
        router.back();
        return;
      }

      router.replace(HISTORIC_FORBIDDEN_FALLBACK_PATH);
    };

    const deniedAction = denied ? handleDenied : undefined;
    deniedAction?.();
  }, [denied, message, router]);
}
